import {HttpContextToken, HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {NzMessageService} from 'ng-zorro-antd/message';
import {catchError, throwError} from 'rxjs';

// Set on requests that should silently swallow errors (e.g. optional preference loads).
export const SILENT_ERROR = new HttpContextToken<boolean>(() => false);

function extractMessage(err: HttpErrorResponse): string {
    if (err.error?.error) {
        const main   = err.error.error as string;
        const fields = err.error.fields as Record<string, string> | undefined;
        if (fields && Object.keys(fields).length > 0) {
            return `${main} — ${Object.entries(fields).map(([k, v]) => `${k}: ${v}`).join('; ')}`;
        }
        return main;
    }
    if (err.status === 0)   return 'Errore di rete: controlla la connessione';
    if (err.status === 401) return 'Sessione non autorizzata';
    if (err.status === 403) return 'Accesso negato';
    if (err.status === 404) return 'Risorsa non trovata';
    if (err.status >= 500)  return 'Errore del server: riprova più tardi';
    return 'Si è verificato un errore inatteso';
}

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    if (req.context.get(SILENT_ERROR)) return next(req);
    const msg = inject(NzMessageService);
    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            msg.error(extractMessage(err));
            return throwError(() => err);
        })
    );
};
